export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="font-heading text-lg font-semibold text-background-50 mb-3">妖精动漫</h3>
              <p className="text-sm text-background-300 leading-relaxed">
                汇集韩漫、日漫、国漫大全，韩国漫画、日本漫画、国产漫画免费全集在线阅读，下拉式流畅翻页，好看漫画追更不停。
              </p>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-background-50 mb-3">漫画分类</h3>
              <ul className="space-y-1.5 text-sm text-background-300">
                <li><a href="#carousel" className="hover:text-primary-400 transition-colors cursor-pointer">热门专题</a></li>
                <li><a href="#ranking" className="hover:text-primary-400 transition-colors cursor-pointer">人气排行</a></li>
                <li><a href="#index" className="hover:text-primary-400 transition-colors cursor-pointer">漫画索引</a></li>
                <li><a href="#cards" className="hover:text-primary-400 transition-colors cursor-pointer">推荐漫画</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-background-50 mb-3">快速入口</h3>
              <ul className="space-y-1.5 text-sm text-background-300">
                <li><a href="#updates" className="hover:text-primary-400 transition-colors cursor-pointer">最新更新</a></li>
                <li><a href="#topics" className="hover:text-primary-400 transition-colors cursor-pointer">热门话题</a></li>
                <li><a href="#faq" className="hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
                <li><a href="#app" className="hover:text-primary-400 transition-colors cursor-pointer">APP下载</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-background-50 mb-3">合作伙伴</h3>
              <p className="text-sm text-background-400">更多合作伙伴即将上线，敬请期待。</p>
            </div>
          </div>

          <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 妖精动漫 版权所有
            </p>
            <p className="text-xs text-background-400">
              韩漫日漫国漫免费全集在线阅读平台
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}